import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Auth } from 'aws-amplify';
import { clearSessionStorage } from 'helpers/storage';

const baseUrl = `${import.meta.env.REACT_APP_HOSTNAME}/admin/api/v2`;
const tenantUrl = `${import.meta.env.REACT_APP_HOSTNAME}/tenant/api/v2`;
const commonUrl = `${import.meta.env.REACT_APP_HOSTNAME}/common/api/v2`;
const propertyManagerUrl = `${
  import.meta.env.REACT_APP_HOSTNAME
}/property_manager/api/v2`;

type TApiBaseUrl = 'admin' | 'tenant' | 'common' | 'property_manager';

const getBaseUrl = (apiPath?: TApiBaseUrl) => {
  switch (apiPath) {
    case 'admin':
      return baseUrl;
    case 'tenant':
      return tenantUrl;
    case 'common':
      return commonUrl;
    case 'property_manager':
      return propertyManagerUrl;
    default:
      return baseUrl;
  }
};

export const authSplitApi = (
  reducerPath: string,
  tagTypes?: string[],
  apiPah?: TApiBaseUrl,
) =>
  createApi({
    reducerPath,
    baseQuery: fetchBaseQuery({
      baseUrl: getBaseUrl(apiPah),
      prepareHeaders: async headers => {
        try {
          const session = await Auth.currentSession();
          const idTokenExpire = session.getIdToken().getExpiration();
          const refreshToken = session.getRefreshToken();
          const currentTimeSeconds = Math.round(+new Date() / 1000);
          if (idTokenExpire < currentTimeSeconds) {
            try {
              const currentAuthUser = await Auth.currentAuthenticatedUser();
              currentAuthUser.refreshSession(refreshToken, (err: string) => {
                if (err) {
                  clearSessionStorage();
                  window.location.replace(`/login`);
                } else {
                  headers.set(
                    'authorization',
                    `Bearer ${session.getIdToken().getJwtToken()}`,
                  );
                }
              });
            } catch (err) {
              clearSessionStorage();
              window.location.replace(`/login`);
            }
          } else {
            headers.set(
              'authorization',
              `Bearer ${session.getIdToken().getJwtToken()}`,
            );
          }
        } catch (err) {
          clearSessionStorage();
          window.location.replace(`/login`);
        }
        headers.set('X-Acting-App', 'admin');
        return headers;
      },
    }),
    tagTypes: tagTypes || [],
    endpoints: () => ({}),
  });

export const emptySplitApi = (reducerPath: string, apiPath?: TApiBaseUrl) =>
  createApi({
    reducerPath,
    baseQuery: fetchBaseQuery({
      baseUrl: getBaseUrl(apiPath),
      prepareHeaders: headers => {
        headers.set('X-Acting-App', 'admin');
        return headers;
      },
    }),
    endpoints: () => ({}),
  });
